<template>
    <div class="style-quiz-back-wrapper">
        <div class="style-quiz-back">
            <button class="prev" @click="exitStyleQuiz">
                <img src="@/assets/icons/left.svg" :alt="$t('project_details.proposal.slider_arrow_left_alt')" />
                <span>{{$t('style_quiz.go_back')}}</span>
            </button>
        </div>
    </div>

    <create-project-steps-menu :current-step="4"></create-project-steps-menu>

    <div class="furniture loader-block-parent">
        <div v-show="isLoading" class="loader-block">
            <div>
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
        <div class="furniture__left">
            <p class="furniture__heading">{{ $t('style_quiz.deadline.select_deadline') }}</p>
            <p class="furniture__subheading">{{ $t('style_quiz.deadline.select_deadline_desc') }}</p>
        </div>
        <div class="furniture__right">
            <div class="deadline__item"
                 v-for="deadlineType in DEADLINE_TYPES"
                 :class="{
                    'active': selectedDeadline === deadlineType
                 }"
                 @click.prevent="toggleDeadlineType(deadlineType)"
            >
                <div class="indicator"
                     :class="{
                            'checked': selectedDeadline === deadlineType
                         }"
                >
                </div>
                <img :src="DEADLINE_TYPES_ICON[deadlineType]" alt="">
                <p>{{ $t('style_quiz.deadline.' + deadlineType) }}</p>
            </div>
        </div>
    </div>

    <div class="buttons">
        <button @click.prevent="goBack" class="back">{{ $t('style_quiz.deadline.prev') }}</button>
        <button
            class="next"
            @click.prevent="submitDeadline"
            :class="{'disabled': sendingForm}"
            :disabled="sendingForm"
        >
            <template v-if="!sendingForm">
                {{ $t('style_quiz.deadline.next') }}
            </template>
            <template v-else>
                {{ $t('style_quiz.deadline.next') }}...
            </template>
        </button>
    </div>
</template>

<script>
import CreateProjectStepsMenu from "@/components/createProject/CreateProjectStepsMenu";
import {inject, ref} from "vue";
import {useI18n} from "vue-i18n";
import router from "@/router";
import AlertHelper from "@/helpsers/alert.helper";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import TWO_FOUR_WEEKS_ICON from '@/assets/icons/two-four-weeks-calendar.svg';
import FOUR_EIGHT_WEEKS_ICON from '@/assets/icons/four-eight-weeks-calendar.svg';
import EIGHT_TWELVE_WEEKS_ICON from '@/assets/icons/eight-tweelf-weeks-calendar.svg';
export default {
    name: "CreateProjectDeadline",
    components: {CreateProjectStepsMenu},
    setup() {
        let selectedDeadline = ref('');
        const TWO_FOUR_WEEKS = 'TWO_FOUR_WEEKS';
        const FOUR_EIGHT_WEEKS = 'FOUR_EIGHT_WEEKS';
        const EIGHT_TWELVE_WEEKS = 'EIGHT_TWELVE_WEEKS';
        const DEADLINE_TYPES = [
            TWO_FOUR_WEEKS,
            FOUR_EIGHT_WEEKS,
            EIGHT_TWELVE_WEEKS,
        ];
        const DEADLINE_TYPES_ICON = {
            TWO_FOUR_WEEKS: TWO_FOUR_WEEKS_ICON,
            FOUR_EIGHT_WEEKS: FOUR_EIGHT_WEEKS_ICON,
            EIGHT_TWELVE_WEEKS: EIGHT_TWELVE_WEEKS_ICON,
        };
        let alert = inject('alert');
        const {t} = useI18n();
        const sendingForm = ref(false);
        const isLoading = ref(false);

        async function fetchClientDeadline() {
            isLoading.value = true;
            axios.get(ApiHelper.getProjectDetailsUrl(router.currentRoute.value.params.id), {
                headers: authHelper.authHeader(),
            }).then(result => {
                selectedDeadline.value = result?.data?.orderCompletionDate ?? '';
                isLoading.value = false;
            }).catch(errorResponse => {
                if (errorResponse?.response?.data?.code == '404')
                    router.push({path: '/not-found'});
                isLoading.value = false;
            })
        }
        fetchClientDeadline();

        function toggleDeadlineType(type) {
            if (selectedDeadline.value === type)
                selectedDeadline.value = '';
            else
                selectedDeadline.value = type;
        }

        function goBack() {
            router.back()
        }

        const submitDeadline = async () => {
            if (!DEADLINE_TYPES.includes(selectedDeadline.value)) {
                AlertHelper.show(alert, t('style_quiz.deadline.select_deadline'), '', 'info');
            } else {
                sendingForm.value = true;
                const data = {
                    id: router.currentRoute.value.params.id,
                    orderCompletionDate: selectedDeadline.value
                }

                axios.put(ApiHelper.getEditProjectUrl(), data, {
                    headers: authHelper.authHeader()
                }).then((result) => {
                    sendingForm.value = false;
                    router.push({name: 'create-project-budget', params: {id: router.currentRoute.value.params.id}});
                }).catch(({response}) => {
                    sendingForm.value = false;
                    let errorMessage = ApiHelper.getResponseMessage(response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');
                })
            }
        }

        function exitStyleQuiz() {
            router.push({name: 'project-details', params: {id: router.currentRoute.value.params.id, activeTab: 'styleQuiz'}})
        }

        return {
            selectedDeadline,
            TWO_FOUR_WEEKS,
            FOUR_EIGHT_WEEKS,
            EIGHT_TWELVE_WEEKS,
            DEADLINE_TYPES,
            sendingForm,
            toggleDeadlineType,
            goBack,
            submitDeadline,
            DEADLINE_TYPES_ICON,
            exitStyleQuiz,
            isLoading
        }
    }
}
</script>

<style scoped lang="scss">
@use '@/css/quiz';
@use '@/css/custom-quiz';

.furniture {
    .indicator {
        &.checked {
            background-color: #f4f3f3;
            border: 0;
            background-image: url("./../../assets/icons/checkmark-dark.svg");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 70%;
        }
    }
}

.deadline {
    &__item {
        gap: 10px;
    }
}
</style>